module.exports = __webpack_public_path__ + "images/etoto_logo_topMenu.png";